import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";
import Paggination from "./Paggination";
import Loader from "./Loader/Loader";
import useApi from "../hook/useApi";
import { copyToClipboard, trimAddress } from "../utils/helper";
import { IoCopyOutline } from "react-icons/io5";
import { toast } from "react-toastify";

const NewsletterLayer = () => {
     const { AsyncGetApiCall, AsyncDeleteApiCall } = useApi();
     const [query, setQuery] = useState({
          pageNo: 1,
          limitVal: 20,
          search: "",
          isVerified: null,
     });
     const [loading, setLoading] = useState(false);
     const [data, setData] = useState(null);

     const setPageNo = (pageNo) => {
          setQuery((prev) => ({
               ...prev,
               pageNo: pageNo,
          }));
     };

     const getAllNewsletter = async (showLoader = true) => {
          try {
               if (showLoader) {
                    setLoading(true);
               }
               const result = await AsyncGetApiCall("/newsletter/list", query);
               console.log("Result:", result);
               console.log("data", result)

               if (result.success) {
                    setData(result);
               }
               if (showLoader) {
                    setLoading(false);
               }
          } catch (error) {
               console.log("error...", error);
          }
          finally {
               setLoading(false);
          }
     };

     const handleSearch = (e) => {
          const value = e.target.value;

          // Regex to allow only valid email characters (alphanumeric, dots, hyphens, underscores, @)
          const validEmailChars = /^[a-zA-Z0-9._@-]*$/;

          if (validEmailChars.test(value)) {
               // console.log("Only letters, numbers, dots, hyphens, underscores, and @ are allowed.");
               setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
          }
     };

     // Prevent form submission
     const handleFormSubmit = (e) => {
          e.preventDefault(); // Prevent default form submission
     };

     useEffect(() => {
          getAllNewsletter(false);
     }, [query]);

     const handleDelete = async (email) => {
          if (!email) {
               toast.error("Email not found");
               return;
          }
          try {
               setLoading(true);
               const result = await AsyncDeleteApiCall(`/newsletter/delete?email=${email}`);
               if (result.success) {
                    toast.success("Subscriber email removed successfully");
                    getAllNewsletter();
               } else {
                    toast.error(result.message || "Something went wrong");
               }
          } catch (error) {
               console.log("error", error);
          }
          finally {
               setLoading(false);
          }
     };

     return (
          <>
               {loading && <Loader />}
               <div className="card h-100 p-0 radius-12">
                    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                         <div className="d-flex align-items-center flex-wrap gap-3">
                              <span className="text-md fw-medium text-secondary-light mb-0">
                                   Show
                              </span>
                              <select
                                   className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                   value={query.limitVal} // Changed from defaultValue to value
                                   onChange={(e) => {
                                        const value = parseInt(e.target.value, 10);
                                        setQuery((prev) => ({
                                             ...prev,
                                             limitVal: value,
                                             pageNo: 1, // Reset to first page on limit change
                                        }));
                                   }}
                              >
                                   {/* <option value="5">5</option> */}
                                   {Array.from({ length: 20 }, (_, i) => {
                                        const value = (i + 1) * 5;
                                        return (
                                             <option key={value} value={value}>
                                                  {value}
                                             </option>
                                        );
                                   })}
                              </select>
                              <form className="navbar-search" onSubmit={handleFormSubmit}>
                                   <input
                                        type="text"
                                        className="bg-base h-40-px w-auto"
                                        name="search"
                                        placeholder="Search by email"
                                        value={query.search}
                                        onChange={handleSearch}
                                   />
                                   <Icon icon="ion:search-outline" className="icon" />
                              </form>
                         </div>
                    </div>

                    <div className="card-body p-24">
                         <div className="table-responsive scroll-sm">
                              <table className="table bordered-table sm-table mb-0">
                                   <thead>
                                        <tr>
                                             <th scope="col" className="text-center">
                                                  S.No
                                             </th>
                                             <th scope="col" className="text-center">Email</th>
                                             <th scope="col" className="text-center">Created At</th>
                                             <th scope="col" className="text-center">Action</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {data && data.data?.length > 0 ? (
                                             data.data.map((news, index) => (
                                                  <tr key={news._id}>
                                                       <td className="text-center">
                                                            <div className="d-flex justify-content-center align-items-center gap-10">
                                                                 {(data?.pagination?.currentPage - 1) * query.limitVal + index + 1}
                                                            </div>
                                                       </td>
                                                       <td className="text-center">
                                                            {news?.email || "N/A"}
                                                            {
                                                                 news?.email && (
                                                                      <button
                                                                           onClick={() => copyToClipboard(news?.email)}
                                                                           className="ms-3 p-0 border-0 bg-transparent"
                                                                           style={{ lineHeight: 1 }}
                                                                      >
                                                                           <IoCopyOutline />
                                                                      </button>
                                                                 )
                                                            }
                                                       </td>
                                                       <td className="text-center">
                                                            {new Date(news.createdAt).toLocaleString("en-GB", {
                                                                 day: "2-digit",
                                                                 month: "2-digit",
                                                                 year: "numeric",
                                                                 hour: "2-digit",
                                                                 minute: "2-digit",
                                                                 second: "2-digit",
                                                                 hour12: true,
                                                            })}
                                                       </td>
                                                       <td className="text-center">
                                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                                 <button
                                                                      onClick={() => {
                                                                           if (window.confirm("Are you sure you want to delete this subscriber?")) {
                                                                                handleDelete(news?.email)
                                                                           }
                                                                      }}
                                                                      disabled={loading}
                                                                      className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                 >
                                                                      <Icon icon="lucide:trash-2" className="menu-icon" />
                                                                 </button>
                                                            </div>
                                                       </td>
                                                  </tr>
                                             ))
                                        ) : (
                                             <tr>
                                                  <td colSpan="8" className="text-center">
                                                       No newsletter found
                                                  </td>
                                             </tr>
                                        )}
                                   </tbody>
                              </table>
                         </div>
                         <Paggination
                              total={data?.pagination?.total || 0}
                              totalPages={data?.pagination?.totalPages || 0}
                              currentPage={data?.pagination?.currentPage || 0}
                              setPageNo={setPageNo}
                              startFrom={(data?.pagination?.currentPage - 1) * query.limitVal + 1}
                              endTo={
                                   (data?.pagination?.currentPage - 1) * query.limitVal + data?.data?.length
                              }
                         />
                    </div>
               </div>
          </>
     );
};

export default NewsletterLayer;